<template>
  <v-layout row ma-2>
    <v-flex xs12 sm8 offset-sm2>
    <v-card
      class="elevation-1"
    >
      <v-card-title
        primary-title
      >
        <div v-if="ratingStep === 1" class="card-title">{{ $t("rating_st1_title") }}</div>
        <div v-if="ratingStep === 2" class="card-title">
          <div v-if="isGoodRating">
            {{ $t("rating_st2_good_title") }}
          </div>
          <div v-else>
            {{ $t("rating_st2_bad_title") }}
          </div>
        </div>
        <div v-if="ratingStep === 3" class="card-title">{{ $t("rating_st3_title") }}</div>
      </v-card-title>
      <v-card-text v-if="ratingStep === 1">
        <p class="text-xs-left" v-html="$t('rating_st1_message')"></p>
        <div class="text-xs-center mt-1">
          <v-rating
            v-model="rating"
            @input="selectRating()"
            color="orange darken-1"
            background-color="orange lighten-3"
            hover
            large
          ></v-rating>
          <div>
            <span class="caption mr-5">{{ $t("rating_st1_bad_cap") }}</span>
            <span class="caption ml-5">{{ $t("rating_st1_good_cap") }}</span>
          </div>
        </div>
      </v-card-text>
      <v-card-text v-else-if="ratingStep === 2">
        <div v-if="isGoodRating">
          <v-textarea v-if="isGoodRating" outline auto-grow :placeholder="$t('rating_st2_good_ph')" rows="3" v-model="goodInput" class="px-3"></v-textarea>
        </div>
        <div v-else>
          <v-list one-line>
            <template v-for="(badPoint, key) in badPoints">
              <v-list-tile :key="key" @click="badPoint.flag">
                <v-list-tile-action>
                  <v-checkbox v-model="badPoint.flag"></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content @click="badPoint.flag = !badPoint.flag">
                  <v-list-tile-title>{{ badPoint.text }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-textarea :key="key" v-if="badPoint.flag" outline auto-grow :placeholder="badPoint.placeholder" rows="4" v-model="badPoint.input" class="px-3">
              </v-textarea>
            </template>
          </v-list>
        </div>
        <p class="text-xs-left card-subtitle mt-3 mb-2">{{ $t("rating_st2_subtitle") }}</p>
        <v-list one-line>
          <v-radio-group v-model="usecaseRadio">
            <v-list-tile v-for="(usecase, key) in usecases" :key="key" @click="usecaseRadio = usecase">
              <v-list-tile-action>
                <v-radio :value="usecase" color="success"></v-radio>
              </v-list-tile-action>
              <v-list-tile-content @click="usecaseRadio = usecase">
                <v-list-tile-title>{{ usecase }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-radio-group>
        </v-list>
        <v-divider></v-divider>
        <v-btn dark round outline color="primary" class="mt-3" @click="submitDetail()">{{ $t("rating_st2_submit") }}</v-btn>
      </v-card-text>
      <v-card-text v-else>
        <p class="text-xs-left">{{ $t("rating_st3_message") }}</p>
      </v-card-text>
    </v-card>

    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import {
  API_BASE_URL,
} from "@/settings";

function serviceShortName(name) {
  if (name === 'photo_refiner') {
    return 'pr';
  } else if (name === 'sai_chan') {
    return 'sc';
  } else if (name === 'enpainter') {
    return 'ep';
  } else if (name === 'line_drawer') {
    return 'lid';
  } else if (name === 'mono_painter') {
    return 'mp';
  } else if (name === 'portrait_drawer') {
    return 'pd';
  } else if (name === 'anime_art_painter') {
    return 'aap';
  } else if (name === 'png_smallify') {
    return 'ps';
  } else if (name === 'face_refiner') {
    return 'fr';
  }
}

export default {
  props: {
    serviceName: {
      type: String,
      default: '',
    },
    requestId: {
      type: String,
      default: '',
    },
  },
  data () {
    const st2BadPh = 'rating_st2_bad1_ph_' + serviceShortName(this.serviceName);
    return {
      rating: 0,
      ratingThreshold: 4,
      ratingStep: 1,
      goodInput: '',
      badPoints: [
        {
          flag: false,
          text: this.$t('rating_st2_bad1'),
          input: '',
          placeholder: this.$t(st2BadPh).replace(/\\n/g, '\n'),
        },
        {
          flag: false,
          text: this.$t('rating_st2_bad2'),
          input: '',
          placeholder: this.$t('rating_st2_bad2_ph').replace(/\\n/g, '\n'),
        },
        {
          flag: false,
          text: this.$t('rating_st2_bad3'),
          input: '',
          placeholder: this.$t('rating_st2_bad3_ph').replace(/\\n/g, '\n'),
        },
      ],
      usecaseRadio: '',
      usecases: [
        this.$t('rating_usecase1'),
        this.$t('rating_usecase2'),
        this.$t('rating_usecase3'),
      ],
    }
  },
  computed: {
    isGoodRating() {
      if (this.rating >= this.ratingThreshold) {
        return true;
      } else {
        return false;
      }
    },
    getRequestId() {
      if (this.requestId !== '') {
        return this.requestId;
      } else {
        return this.$route.params.requestId;
      }
    },
    getGroupId() {
      const group = this.$store.getters["user/currentGroup"];
      return group.id;
    },
  },
  methods: {
    selectRating() {
      this.postRatingScore();
      this.ratingStep = 2;
    },
    submitDetail() {
      this.postRatingDetail();
      this.ratingStep = 3;
    },
    async postRatingScore() {
      const param = {
        lang: this.$i18n.locale,
        service: this.serviceName,
        group_id: this.getGroupId,
        request_id: this.getRequestId,
        rating: this.rating,
      };

      const res = await axios.post(
        `${API_BASE_URL}/rating/post_score`,
        param
      );
      if (res.status != 200) {
        console.log("[ERROR] ", res.data);
        return;
      }
    },
    async postRatingDetail() {
      const param = {
        lang: this.$i18n.locale,
        service: this.serviceName,
        group_id: this.getGroupId,
        request_id: this.getRequestId,
        rating: this.rating,
        good_input: '',
        bad_point_choices: [],
        bad_point_inputs: [],
        usecase: this.usecaseRadio,
      };

      if (this.isGoodRating) {
        param.good_input = this.goodInput;
      } else {
        param.bad_point_choices = this.badPoints.filter(function(item) {
          return item.flag;
        }).map(function(item) {
          return item.text;
        });
        param.bad_point_inputs = this.badPoints.filter(function(item) {
          return item.flag;
        }).map(function(item) {
          return item.input;
        });
      }

      const res = await axios.post(
        `${API_BASE_URL}/rating/post_detail`,
        param
      );
      if (res.status != 200) {
        console.log("[ERROR] ", res.data);
        return;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";

.card-title {
  font-size: 20px;
  font-weight: 400;
  line-height: 1;
  letter-spacing: .02em;
}

/deep/ .v-input__slot {
  box-shadow: none !important;
}

/deep/ .v-text-field__slot textarea {
  font-size: 14px;
  line-height: 1.5;
  margin-top: 0px !important;
}

/deep/ .v-input--selection-controls .v-input__control {
  flex-grow: inherit;
}

/deep/ .v-list__tile__sub-title, .v-list__tile__title {
  display: flex;
  align-items: center;
  height: 42px;
  font-size: 14px;
  white-space: normal;
  overflow: visible;
}

.card-subtitle {
    font-size: 18px;
    font-weight: 400;
    line-height: 1;
    letter-spacing: .02em;
}
</style>
<i18n src="@/locales/components/rating.json"></i18n>
